import React, { useEffect, useState } from "react";
import { Table, Switch, Input, message, Button, Form, Tabs, Modal, Popconfirm, Tooltip } from "antd";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import config from "../config";
import "./Perferences.css";
import Swal from "sweetalert2";
import { jwtDecode } from 'jwt-decode';
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const Perferences = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [voidReasonInput, setVoidReasonInput] = useState("");
  const [voidReasonLoading, setVoidReasonLoading] = useState(false);
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editReason, setEditReason] = useState("");
  const [editId, setEditId] = useState(null);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      setSettings(data);
      setPaymentMethods(Array.isArray(data.paymentMethods) ? data.paymentMethods : []);
      form.setFieldsValue({
        invoicePrefix: data.invoicePrefix || "",
        invoicePrefixNumber: data.invoicePrefixNumber || "",
        invoiceSuffix: data.invoiceSuffix || "",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch settings",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
    // eslint-disable-next-line
  }, []);

  const handleToggle = async (key, value) => {
    setLoading(true);
    try {
      await axios.put(`${apiBaseUrl}/api/settings/edit-settings`, {
        ...settings,
        [key]: value,
      });
      setSettings((prev) => ({ ...prev, [key]: value }));

      console.log(key, value);
      
      if(key=='isAccessKeyNeeded'&& value==false){
        console.log('isAccessKeyNeeded is false');
      console.log(key, value);
        
        const decoded = jwtDecode(JSON.parse(localStorage.getItem('auth')).token);
              const userId = decoded.userId;
console.log('userId:',userId);

localStorage.setItem('userId',userId);

      }
      Swal.fire({
        title: "Success",
        text: "Setting Updated",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to Update Setting",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInvoicePrefixSubmit = async (allValues) => {
    setLoading(true);
    try {
      await axios.put(`${apiBaseUrl}/api/settings/edit-settings`, {
        ...settings,
        invoicePrefix: allValues.invoicePrefix,
        invoicePrefixNumber: allValues.invoicePrefixNumber,
        invoiceSuffix: allValues.invoiceSuffix,
      });
      setSettings((prev) => ({
        ...prev,
        invoicePrefix: allValues.invoicePrefix,
        invoicePrefixNumber: allValues.invoicePrefixNumber,
        invoiceSuffix: allValues.invoiceSuffix,
      }));
      Swal.fire({
        title: "Success",
        text: "Invoice prefix updated",
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update invoice prefix",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTogglePaymentMethod = async (id, enabled) => {
    const updated = paymentMethods.map(m =>
      m.id === id ? { ...m, enabled } : m
    );
    setPaymentMethods(updated);

    // Find the payment method name for the message
    const methodObj = paymentMethods.find(m => m.id === id);
    const methodName = methodObj ? methodObj.name : id;

    // Fetch current settings from backend
    try {
      const { data: currentSettings } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      // Update paymentMethods
      const updatedSettings = { ...currentSettings, paymentMethods: updated };
      // Remove MongoDB-specific fields if present
      delete updatedSettings._id;
      delete updatedSettings.__v;
      // Send full settings object
      await axios.put(`${apiBaseUrl}/api/settings/edit-settings`, updatedSettings);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: `${methodName} payment ${enabled ? 'enabled' : 'disabled'} successfully`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error('Failed to update payment methods:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Failed to update ${methodName} payment`,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  // Add Void Reason
  const handleAddVoidReason = async () => {
    if (!voidReasonInput.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Please enter a reason.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }
    setVoidReasonLoading(true);
    try {
      const { data } = await axios.post(`${apiBaseUrl}/api/settings/void-reasons`, { reason: voidReasonInput });
      setSettings(prev => ({
        ...prev,
        voidReasons: [...(prev.voidReasons || []), data]
      }));
      setVoidReasonInput("");
      setAddModalVisible(false);
      Swal.fire({
        icon: "success",
        title: "Void reason added.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to add void reason.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setVoidReasonLoading(false);
    }
  };

  // Edit Void Reason
  const showEditModal = (record) => {
    setEditId(record.id);
    setEditReason(record.reason);
    setEditModalVisible(true);
  };
  const handleEditVoidReason = async () => {
    if (!editReason.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Please enter a reason.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }
    setVoidReasonLoading(true);
    try {
      const { data } = await axios.put(`${apiBaseUrl}/api/settings/void-reasons/${editId}`, { reason: editReason });
      setSettings(prev => ({
        ...prev,
        voidReasons: prev.voidReasons.map(r => r.id === editId ? data : r)
      }));
      setEditModalVisible(false);
      setEditId(null);
      setEditReason("");
      Swal.fire({
        icon: "success",
        title: "Void reason updated.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to update void reason.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setVoidReasonLoading(false);
    }
  };

  // Delete Void Reason
  const handleDeleteVoidReason = async (id) => {
    setVoidReasonLoading(true);
    try {
      await axios.delete(`${apiBaseUrl}/api/settings/void-reasons/${id}`);
      setSettings(prev => ({
        ...prev,
        voidReasons: prev.voidReasons.filter(r => r.id !== id)
      }));
      Swal.fire({
        icon: "success",
        title: "Void reason deleted.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to delete void reason.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      setVoidReasonLoading(false);
    }
  };

  const columns = [
    {
      title: "Preferences",
      dataIndex: "name",
      key: "name",
      width: 220,
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: false,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 350,
      sorter: (a, b) => a.description.localeCompare(b.description),
      showSorterTooltip: false,
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      render: (value, record) => {
        if (record.key === "invoicePrefixToggle") {
          return (
            <Switch
              checked={!!settings.invoicePrefixToggle}
              onChange={(checked) => handleToggle("invoicePrefixToggle", checked)}
              loading={loading}
            />
          );
        }
        if (record.key === "invoicePrefixInputs" && settings.invoicePrefixToggle) {
          return (
            <Form
              form={form}
              layout="vertical"
              onFinish={handleInvoicePrefixSubmit}
              style={{ width: '100%' }}
            >
              <Form.Item
                label="Invoice Prefix"
                name="invoicePrefix"
                rules={[{ required: true, message: 'Prefix required' }]}
              >
                <Input
                  placeholder="e.g. INV"
                  value={settings.invoicePrefix}
                />
              </Form.Item>
              <Form.Item
                label="Invoice Prefix Number"
                name="invoicePrefixNumber"
                rules={[{ required: true, message: 'Number required' }]}
              >
                <Input
                  placeholder="e.g. 123456"
                  value={settings.invoicePrefixNumber}
                />
              </Form.Item>
              <Form.Item
                label="Invoice Suffix"
                name="invoiceSuffix"
              >
                <Input
                  placeholder="e.g. AA-21"
                  value={settings.invoiceSuffix}
                />
              </Form.Item>
              <Form.Item style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Update
                </Button>
              </Form.Item>
            </Form>
          );
        }
        if (["sentToKitchenToggle", "deliverDisableToggle", "isSendSeperatedOrderChit","isEinvoiceEnable","isAccessKeyNeeded"].includes(record.key)) {
          return (
            <Switch
              checked={!!settings[record.key]}
              onChange={(checked) => handleToggle(record.key, checked)}
              loading={loading}
            />
          );
        }
        return null;
      },
    },
  ];

  const dataSource = [
    {
      key: "sentToKitchenToggle",
      name: "Send to Kitchen",
      description: "When enabled, orders are sent to the kitchen automatically.",
      value: settings.sentToKitchenToggle,
    },
    {
      key: "deliverDisableToggle",
      name: "Deliver Disable",
      description: "When enabled, the order can skip the 'Delivered' step and proceed directly to checkout.",
      value: settings.deliverDisableToggle,
    },
    {
      key: "isSendSeperatedOrderChit",
      name: "Print Order Chit Item By Item",
      description: "When enabled, order chit will be printed item by item.",
      value: settings.isSendSeperatedOrderChit,
    },
    {
        key:"isEinvoiceEnable",
        name: "Enable e-Invoice",
        description: "When enabled, e-invoice functionality is activated.",
        value: settings.isEinvoiceEnable,
    },
    {
      key: "isAccessKeyNeeded",
      name: "Enable Access Key",
      description: "When enabled, access key is needed for certain actions.",
      value: settings.isAccessKeyNeeded,
    },
    {
      key: "invoicePrefixToggle",
      name: "Use Own Invoice Prefix",
      description: "Enable a custom invoice prefix for invoices.",
      value: settings.invoicePrefixToggle,
    },
    // Show input fields only if toggle is enabled
    ...(settings.invoicePrefixToggle
      ? [{
          key: "invoicePrefixInputs",
          name: "Invoice Prefix Details",
          description: "Set the prefix, number, and suffix for invoices.",
          value: null,
        }]
      : []),

  ];

  return (
    <DefaultLayout showSearch={false}>
    
      <Tabs defaultActiveKey="generalSettings">
        <Tabs.TabPane tab="Preferences" key="prefereneces">
          <Table
            className="preferences"
            columns={columns}
            dataSource={dataSource}
            pagination={{
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
              defaultPageSize: 10,
            }}
            rowKey="key"
            loading={loading}
            bordered
          />
        </Tabs.TabPane>
        
        <Tabs.TabPane tab="Payment Methods" key="paymentMethods">
          <Table
            columns={[
              { 
                title: "Name", 
                dataIndex: "name", 
                width: 200,
                sorter: (a, b) => a.name.localeCompare(b.name),
                showSorterTooltip: false,
              },
              {
                title: "Availability",
                dataIndex: "enabled",
                filters: [
                  { text: 'Enabled', value: true },
                  { text: 'Disabled', value: false },
                ],
                onFilter: (value, record) => record.enabled === value,
                render: (enabled, record) => (
                  <Switch
                    checked={enabled}
                    onChange={checked => handleTogglePaymentMethod(record.id, checked)}
                  />
                ),
                width: 120,
              },
            ]}
            dataSource={paymentMethods}
            rowKey="id"
            bordered
            pagination={{
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
              defaultPageSize: 10,
            }}
            style={{ marginBottom: 32 }}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Void Reasons" key="voidReasons">
          <div style={{ marginBottom: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <Button
              type="primary"
              onClick={() => setAddModalVisible(true)}
              disabled={voidReasonLoading}
            >
              Add Reason
            </Button>
          </div>
          <Table
            columns={[
              {
                title: "Reason",
                dataIndex: "reason",
                key: "reason",
                sorter: (a, b) => a.reason.localeCompare(b.reason),
                showSorterTooltip: false,
              },
              {
                title: "Actions",
                key: "actions",
                width: 100,
                align: 'center',
                render: (_, record) => (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                    <Tooltip title="Edit">
                      <EditOutlined
                        style={{ cursor: "pointer", fontSize: 20, color: "#1890ff" }}
                        onClick={() => showEditModal(record)}
                        disabled={voidReasonLoading}
                      />
                    </Tooltip>
                    <Popconfirm
                      title="Are you sure you want to delete this void reason?"
                      onConfirm={() => handleDeleteVoidReason(record.id)}
                      okText="Yes"
                      cancelText="No"
                      placement="left"
                      disabled={voidReasonLoading}
                    >
                      <Tooltip title="Delete">
                        <DeleteOutlined style={{ cursor: "pointer", fontSize: 20, color: "red" }} />
                      </Tooltip>
                    </Popconfirm>
                  </div>
                ),
              },
            ]}
            dataSource={Array.isArray(settings.voidReasons) ? settings.voidReasons : []}
            rowKey="id"
            bordered
            loading={voidReasonLoading}
            pagination={{
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
              defaultPageSize: 10,
            }}
          />
          {/* Add Modal */}
          <Modal
            title="Add Void Reason"
            open={addModalVisible}
            onOk={handleAddVoidReason}
            onCancel={() => { setAddModalVisible(false); setVoidReasonInput(""); }}
            okText="Add"
            confirmLoading={voidReasonLoading}
          >
            <Input
              placeholder="Enter new void reason"
              value={voidReasonInput}
              onChange={e => setVoidReasonInput(e.target.value)}
              onPressEnter={handleAddVoidReason}
              disabled={voidReasonLoading}
            />
          </Modal>
          {/* Edit Modal */}
          <Modal
            title="Edit Void Reason"
            open={editModalVisible}
            onOk={handleEditVoidReason}
            onCancel={() => { setEditModalVisible(false); setEditId(null); setEditReason(""); }}
            okText="Save"
            confirmLoading={voidReasonLoading}
          >
            <Input
              value={editReason}
              onChange={e => setEditReason(e.target.value)}
              onPressEnter={handleEditVoidReason}
              disabled={voidReasonLoading}
            />
          </Modal>
        </Tabs.TabPane>
      </Tabs>
    </DefaultLayout>
  );
};

export default Perferences; 